import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { createExpectedInternalTransferAsync } from '../../../API/accounting/createExpectedInternalTransferAsync';
import { IUnrestrictedInternalTransferData } from '../../../types/accounting/data/IUnrestrictedInternalTransferData';

export const { slice: createInternalTransferSlice, asyncAction: createInternalTransferAction } =
  createAsyncSliceWithDataAndQuery(
    'createInternalTransfer',
    createExpectedInternalTransferAsync,
    {} as IUnrestrictedInternalTransferData
  );
